import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const TIERS = [
  { k: "platinum", l: "Platinum Partners", size: "h-24 md:h-28" },
  { k: "gold", l: "Gold Partners", size: "h-20 md:h-24" },
  { k: "standard", l: "Community Partners", size: "h-16 md:h-20" },
];

function SponsorLogo({ s, size }) {
  const content = s.logo ? (
    <img src={s.logo} alt={s.name} className={`${size} w-auto object-contain`} />
  ) : (
    <div className={`${size} flex items-center justify-center px-6 rounded-2xl border border-axe-border bg-axe-surface text-white font-display font-black text-xl tracking-[0.15em]`}>
      {s.name}
    </div>
  );
  return s.url && s.url !== "#" ? (
    <a href={s.url} target="_blank" rel="noreferrer" className="transition-opacity hover:opacity-80" data-testid={`sponsor-${s.id}`}>
      {content}
    </a>
  ) : (
    <div data-testid={`sponsor-${s.id}`}>{content}</div>
  );
}

export default function Sponsors() {
  const [all, setAll] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/sponsors").then((r) => setAll(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const byTier = useMemo(() => {
    const m = { platinum: [], gold: [], standard: [] };
    for (const s of all) {
      (m[s.tier] || m.standard).push(s);
    }
    return m;
  }, [all]);

  return (
    <div data-testid="sponsors-page" className="text-white">
      <section className="max-w-7xl mx-auto px-5 md:px-8 pt-16 md:pt-24">
        <div className="text-xs uppercase tracking-[0.35em] text-axe-tangerine font-bold">
          Partners
        </div>
        <h1 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl">
          Sponsors & <span className="text-axe-purple">Partners</span>
        </h1>
        <p className="mt-5 max-w-2xl text-neutral-400 text-base sm:text-lg">
          The brands that back AXE and help us push the competitive line forward.
        </p>
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 mt-12 space-y-14">
        {loading ? (
          <div className="text-neutral-400">Loading…</div>
        ) : (
          TIERS.map((tier) => (
            (byTier[tier.k] || []).length > 0 && (
              <div key={tier.k}>
                <div className="text-xs uppercase tracking-[0.35em] text-axe-tangerine font-bold">
                  {tier.l}
                </div>
                <div className="mt-6 flex flex-wrap items-center gap-10">
                  {byTier[tier.k].map((s) => (
                    <SponsorLogo key={s.id} s={s} size={tier.size} />
                  ))}
                </div>
              </div>
            )
          ))
        )}
      </section>

      <section className="max-w-7xl mx-auto px-5 md:px-8 mt-20">
        <div className="rounded-3xl border border-axe-border bg-axe-surface p-10 md:p-14 text-center">
          <div className="text-xs uppercase tracking-[0.35em] text-axe-tangerine font-bold">
            Become a Partner
          </div>
          <h3 className="mt-3 font-display font-black text-3xl sm:text-4xl">
            Back a roster with real reach.
          </h3>
          <p className="mt-4 text-neutral-400 max-w-2xl mx-auto">
            Jersey placement, stream overlays, creator collabs, tournament activations. Let's
            build something memorable together.
          </p>
          <a
            href="/contact"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-axe-purple px-7 py-3.5 font-bold uppercase tracking-[0.22em] text-white hover:bg-axe-purple-hover drop-shadow-[0_0_14px_rgba(176,38,255,0.45)]"
          >
            Talk to Partnerships
          </a>
        </div>
      </section>
    </div>
  );
}
